const getLocale = (locale) => {
  if (locale === 'es') {
    return 'es-mx'
  } else if (locale === 'en') {
    return 'en-us'
  }
}

export default getLocale
